<template>
        <div class="modal-mask" @click="$emit('close')" id="case-list-modal">
          <div class="modal" id="caseModal" tabindex="-1" role="dialog" aria-labelledby="caseModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
              <div class="modal-content" @click.stop>
                <div class="modal-header">
                  <div class="text-left">
                    <h3 class="modal-title">{{ c.name }}</h3>
                  </div>
                  <button type="button" class="close" @click="$emit('close')" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="body-footer">
                  <div class="modal-body">
                    <swiper v-if="c.casepics&&c.casepics.length>0" :options="swiperOption" :key="c.id">
                      <swiper-slide v-for="img in c.casepics" :key="img">
                        <img class="casePic" :src="img" alt="">
                      </swiper-slide>
                      <div class="swiper-pagination" slot="pagination"></div>
                      <div class="swiper-button-prev" slot="button-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z"></svg></div>
                      <div class="swiper-button-next" slot="button-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z"></svg></div>
                    </swiper>
                    <img v-else class="casePic" :src="c.img" alt="">
                  </div>
                  <div class="modal-footer justify-content-start">
                      <table class="table table-bordered case-table">
                          <tr>
                              <th>聯絡電話</th>
                              <td>{{ c.phone }}</td>
                          </tr>
                          <tr>
                              <th>基地位置</th>
                              <td>{{ c.address }}</td>
                          </tr>
                          <tr>
                              <th>產品規劃</th>
                              <td>{{ c.plan }}</td>
                          </tr>
                          <tr>
                              <th>建築外觀</th>
                              <td>{{ c.apperance }}</td>
                          </tr>
                          <tr>
                              <th>公設景觀</th>
                              <td>{{ c.public_view }}</td>
                          </tr>
                          <tr>
                              <th>工程營造</th>
                              <td>{{ c.construction_company }}</td>
                          </tr>
                          <tr>
                              <th>結構設計</th>
                              <td>{{ c.structure_designer }}</td>
                          </tr>
                          <tr>
                              <th>分享</th>
                              <td>
                                <a @click="socialShare('fb')" class="social-icon"><i class="fab fa-facebook-f fa-2x clickable"></i>
                                </a>
                                <a @click="socialShare('line')" class="social-icon"><i class="fab fa-line fa-2x clickable"></i>
                                </a>
                                <a @click="socialShare('whatsapp')" class="social-icon"><i class="fab fa-whatsapp fa-2x clickable"></i>
                                </a>
                                <a @click="socialShare('weibo')" class="social-icon"><i class="fab fa-weibo fa-2x clickable"></i>
                                </a>
                                <a @click="socialShare('twitter')" class="social-icon"><i class="fab fa-twitter fa-2x clickable"></i>
                                </a>
                              </td>
                          </tr>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'CaseListModal',
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    c: Object,
  },
  data() {
    return {
      swiperOption: {
        effect: 'fade',
        loop: true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    }
  },
  methods: {
    socialShare(socialMedia) {
      let link = `${window.location.protocol}//${window.location.hostname}/?case=${this.c.id}`;
      let publicMsg = encodeURIComponent(`京倫建設高品質建案 - ${this.c.name}，分享給大家！`);
      let directMsg = encodeURIComponent(`京倫建設高品質建案 - ${this.c.name}，分享給你！\n${link}`);
      let tag = `#京倫建設 #${this.c.name}`;
      switch (socialMedia) {
        case 'fb':
          this.shareFB(link, tag);
          break;
        case 'twitter':
          this.shareTwitter(link, publicMsg);
          break;
        case 'line':
          this.shareLine(directMsg);
          break;
        case 'whatsapp':
          this.shareWhatsApp(directMsg);
          break;
        case 'weibo':
          this.shareWeibo(link, publicMsg);
        case 'copy':
          this.copyLink(link);
          break;
        default:
          break;
      }
    },
    shareFB(link) {
      window.open(`https://www.facebook.com/sharer.php?u=${encodeURIComponent(link)}`, 'sharer', 'toolbar=0,status=0,width=626,height=436');
    },
    shareTwitter(link, msg) {
      const twitterUrl = `https://twitter.com/home/?status=${msg} ${encodeURIComponent(link)}`;
      window.open(twitterUrl,'sharer','toolbar=0,status=0,width=626,height=436');
    },
    shareLine(msg) {
      if (this.mobileAndTabletcheck()) {
        window.open(`https://line.me/R/msg/text/?${msg}`, '_self');
      } else {
        window.open(`https://social-plugins.line.me/lineit/share?url=&text=${msg}&from=line_scheme`, '_self');
      }
    },
    shareWhatsApp(msg) {
      window.open(`https://api.whatsapp.com/send?text=${msg}`, '_self');
    },
    shareWeibo(link, msg) {
      window.open(`http://v.t.sina.com.cn/share/share.php?title=${msg}&url=${encodeURIComponent(link)}&source=bookmark`, '_blank', 'width=450,height=400');
    },
    mobileAndTabletcheck() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  }
}
</script>

<style scoped>
.modal-default-button {
  float: right;
}
th {
  text-align: center;
  width: 110px;
}
td {
  text-align: left;
}
.hidden {
  visibility: hidden;
}
#caseModal {
  display: block;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
}
.modal-mask.noshow {
  display: none;
}
.modal-header {
  padding-bottom: 0.5rem;
}
.modal-body {
  overflow-y: visible;
  background-color: #222;
  padding: 0;
  height: 42vh;
}
.modal-footer {
  overflow-y: auto;
  display: block;
  height: 42vh;
}
.casePic{
  width: 100%;
  height: 42vh;
}
@media (min-width: 992px) {
  .modal-dialog {
    max-width: 95%;
  }
  .modal-body {
    overflow-y: visible;
    background-color: #222;
    width: 50%;
    height: 83.1vh;
  }
  .modal-footer {
    width: 50%;
    height: 83.1vh;
  }
  .body-footer {
    display: flex;
  }
  .casePic{
    height: 83.1vh;
  }
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color:  rgba(11, 109, 49, 0.842);;
}
.swiper-button-next, .swiper-button-prev {
    background-image: none;
    fill: rgba(11, 109, 49, 0.842);
}
.social-icon {
  margin-right: 4%;
}
.case-table {
  font-size: 1.3rem;
}
</style>